import AbstractController from '../src/services/ControllersRepository/AbstractController';
import IndexPage from '@views/knowledge/pages/IndexPage';
import UpdatePage from '@views/knowledge/pages/UpdatePage';
import CreatePage from '@views/knowledge/pages/CreatePage';

export default class Knowledge extends AbstractController {
    protected controllerName = 'Knowledge';

    protected getDefaultActionsWithComponents() {
        return {
            index: IndexPage,
            show: UpdatePage,
            create: CreatePage,
        };
    }
}
